import { SET_ACCOUNT } from "./actions"

const INITIAL_STATE = {
  account: null,
}

export default function accountReducer(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case SET_ACCOUNT:
      return { ...state, account: action.user }
    default:
      return state
  }
}
